
<template>
  <!-- 季度选择时间控件 -->
  <div class="input-rang">
    <el-input
      v-model="minNumber"
      :type="type"
      :clearable="false"
      style="width: 47%;float: left;"
      @change="changeTime"
      placeholder="">
    </el-input>
    <span style="text-align: center;"> -</span>

    <el-input
      v-model="maxNumber"
      :type="type"
      :clearable="false"
      style="width: 47%;float: right;"
      @change="changeTime"
      placeholder="">
    </el-input>
  </div>
</template>
<script>
/**
 * @file:  View 组件 数值区间控件
 * @description: UI组件  可填写数值区间
 * 代码中注释部分是组件原默认时间配置，我这里做了更改，但是原设置可以参考
 */
export default {
  name: 'inputRang',
  props: {
    value: {
      type: Array,
      default() {
        return [];
      }
    },
    type: {
      type: String,
      default() {
        return 'text';
      }
    }
  },
  data() {
    return {
      minNumber: this.value[0],
      maxNumber: this.value[1],
    };
  },

  mounted() {
    this.minNumber = this.value[0] || '';
    this.maxNumber = this.value[1] || '';
  },
  watch: {
    value: function (val) {
      this.minNumber = val[0];
      this.maxNumber = val[1];
    }
  },
  methods: {
    changeTime() {
      // if (this.maxNumber === '') {
      //   return '';
      // }
      // console.log(this.maxNumber, +this.maxNumber <= +this.minNumber);
      if (+this.maxNumber && +this.maxNumber <= +this.minNumber) {
        const maxTime = this.minNumber;
        this.minNumber = this.maxNumber;
        this.maxNumber = maxTime;
      }
      const Timer = [`${this.minNumber}`, `${this.maxNumber}`];
      this.$emit('input', Timer);
      return '';
    },


  }
};
</script>

<style lang="scss">
.input-rang{
  text-align: center;
  background-color: #fff;
}
</style>
